export default __webpack_public_path__ + "locales/lv/Notifications.json?hash=63d8019e41c32cda72b0f084c86234bf";